import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { Slider } from '@mui/material'

import { ViewLine, CalculText, CalculTextInput, CalculTextRight } from './LineStyleComponent'
import TextInputAdornment from './TextInputAdornment'
import { Text } from '../Native/Text'

const isDouble = (value: unknown) => {
  return typeof value === 'number' || value instanceof Number
}
export type TextInputSliderLineProps = {
  title?: string
  sliderMultiplier?: number
  sliderMin: number
  sliderMax: number
  precision?: number
  sliderStep?: number
  unit?: string
  variableName: string
  calculCode: CalculCodeStateKeys
  trunc?: number
  /**
   * launch calcul
   *
   * @type {boolean}
   */
  doCalcul?: boolean
  /**
   *
   * if true element is the first
   * @type {boolean}
   */
  first?: boolean
  /**
   *
   *if true element is the last
   * @type {boolean}
   */
  last?: boolean
}
export type TextInputSliderLineManualProps = {
  title?: string
  sliderMin: number
  sliderMax: number
  precision?: number
  sliderStep?: number
  unit?: string
  value: number
  update: (val: number) => void
  /**
   *
   * if true element is the first
   * @type {boolean}
   */
  first?: boolean
  /**
   *
   *if true element is the last
   * @type {boolean}
   */
  last?: boolean
}
const TextInputSliderLine = (props: TextInputSliderLineProps) => {
  const [value, update] = useContextValue(props.variableName, props.calculCode, props.doCalcul ?? false)
  const text = useMemo(() => {
    let tex = ''
    if (props.title) {
      tex = i18n.t(props.title)
    } else {
      tex = i18n.t(`${props.calculCode}_${props.variableName}`)
    }
    return tex
  }, [props.calculCode, props.title, props.variableName])

  return <TextInputSliderLineManual value={value} title={text} update={update} {...props} />
}

export const TextInputSliderLineManual = ({
  value,
  update,
  title,
  sliderMin,
  sliderMax,
  precision = 1,
  sliderStep = 0.1,
  unit,
  first = false,
  last = false
}: TextInputSliderLineManualProps) => {
  const text = useMemo(() => {
    let tex = ''
    if (title) {
      tex = i18n.t(title)
    }
    if (sliderMin === sliderMax && unit) {
      tex += ` [${unit}]`
    }
    return tex
  }, [sliderMax, sliderMin, title, unit])

  const textInputRef = useRef(null)
  const [inputVal, setInputVal] = useState('0')

  useEffect(() => {
    if (isDouble(value)) {
      setInputVal(String(+value))
    }
  }, [value])

  const _onSliderChange = useCallback(
    //@ts-ignore
    (event, num) => {
      const stringValue = num.toFixed(precision)
      setInputVal(stringValue)
      //setInputVal(newNumber)
      const formattedValue = parseFloat(stringValue.replace(',', '.'))
      update(formattedValue)
      // onChange(parseFloat(newNumber.replace(',', '.')), variableName)
    },
    [precision, update]
  )

  const _onEndEditing = useCallback(() => {
    const result = parseFloat(inputVal.replace(',', '.'))
    if (isNaN(result)) {
      setInputVal(String(+value))

      update(0)
    } else if (String(value) === inputVal) {
      update(value)
    } else {
      update(result)
    }
  }, [inputVal, update, value])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _onChangeText = useCallback((event: any) => {
    setInputVal(event.target.value)
  }, [])

  const onFocus = useCallback(() => {
    setInputVal('')
  }, [])

  // const _onTouchCell = useCallback(() => {
  //   if (onDisclosurePress != null) {
  //     let val = 0 || parseFloat(inputVal.replace(',', '.'))
  //     // if (value != null) {
  //     onDisclosurePress(val, extraParam)
  //     //  }
  //   } else {
  //     //textInputRef?.current?.focus()
  //   }
  // }, [extraParam, inputVal, onDisclosurePress])
  const onKeypress = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      if (e.key === 'Enter') {
        _onEndEditing()
      }
    },
    [_onEndEditing]
  )
  if (sliderMax === sliderMin) {
    return (
      <ViewLine first={first} last={last}>
        <CalculText>{text}</CalculText>

        <CalculTextRight>{value}</CalculTextRight>
      </ViewLine>
    )
  }
  return (
    <>
      <ViewLine first={first} sx={{ borderBottomWidth: 0 }}>
        <CalculText>{text}</CalculText>

        <CalculTextInput
          ref={textInputRef}
          value={inputVal}
          onFocus={onFocus}
          onChange={_onChangeText}
          onKeyPress={onKeypress}
          onBlur={_onEndEditing}
          variant="outlined"
          size="small"
          InputProps={{
            endAdornment: <TextInputAdornment text={unit} />
          }}
        />
      </ViewLine>
      <ViewLine last={last} sx={{ borderTopWidth: 0 }}>
        <Text>{sliderMin}</Text>
        <Slider
          value={value}
          onChangeCommitted={_onSliderChange}
          onChange={_onSliderChange}
          min={sliderMin}
          max={sliderMax}
          step={sliderStep}
          // eslint-disable-next-line react-native/no-inline-styles
          style={{ marginLeft: 24, marginRight: 24 }}
        />
        <Text>{sliderMax}</Text>
      </ViewLine>
    </>
  )
}

export default memo(TextInputSliderLine)
